<template>
  <div>
    <project-toolbar
      :selectMonth="true"
      :selectProject="true"
      :project="accountProject"
      :showCreditFilter="true"
    />

    <md-content>
      <div v-if="true" class="md-layout first-line">
        <MonthlyCost
          :data="thisMonthCostContent"
          :currency="displayCurrency"
          class="md-layout-item"
        />

        <MonthlyCost
          :data="lastMonthCostContent"
          :currency="displayCurrency"
          class="md-layout-item"
        />

        <PromotionCredit
          v-if="promotionCreditData.length > 0"
          :data="promotionCreditData"
          class="md-layout-item md-size-50 md-small-size-100 md-xsmall-size-100"
        />
      </div>

      <div v-if="true" class="md-layout">
        <template v-for="item in $config.billing.summary.costShareItems">
          <CostShare
            :key="item"
            v-if="item == 'costByCountry' && $config.feature.costByCountry"
            titleKey="costByCountry"
            nameKey="country"
            :data="costByCountryContent"
            :currency="displayCurrency"
            :class="costShareClass"
            @click="openDetailPopup"
            class="md-layout-item"
          />

          <CostShare
            :key="item"
            v-if="item == 'costByRegion' && $config.feature.costByRegion"
            titleKey="costByRegion"
            nameKey="region"
            :data="costByRegionContent"
            :currency="displayCurrency"
            :class="costShareClass"
            @click="openDetailPopup"
            class="md-layout-item"
          />

          <CostShare
            :key="item"
            v-if="
              item == 'costByProject' && hasProject && projectId === '__total'
            "
            titleKey="costByProject"
            nameKey="project"
            :data="costByProjectContent"
            :currency="displayCurrency"
            :class="costShareClass"
            @click="openDetailPopup"
            class="md-layout-item"
          />

          <CostShare
            :key="item"
            v-if="item == 'costByService'"
            titleKey="costByService"
            nameKey="service"
            :data="costByServiceContent"
            :currency="displayCurrency"
            :class="costShareClass"
            @click="openDetailPopup"
            class="md-layout-item"
          />
        </template>
      </div>

      <div class="md-layout mg-change">
        <DailyCost
          titleKey="dailyCost"
          :data="dailyCostContent"
          :currency="displayCurrency"
          class="md-layout-item md-size-100"
        />
      </div>

      <div class="md-layout mg-change">
        <DailyCost
          titleKey="stackedCost"
          :data="dailyStackedCostContent"
          :currency="displayCurrency"
          class="md-layout-item md-size-100"
        />
      </div>
    </md-content>

    <!-- detail information dialog -->
    <md-dialog
      v-if="detailDialog.show"
      :md-active.sync="detailDialog.show"
      class="md-dialog-big"
    >
      <md-dialog-title>{{ detailDialog.title }}</md-dialog-title>

      <md-dialog-content>
        <md-table v-model="detailDialog.list" md-fixed-header md-thin md-stripe>
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell
              v-for="field in detailDialog.fields"
              :key="field"
              :md-label="L(field)"
              >{{ item[field] }}</md-table-cell
            >
            <md-table-cell :md-label="L('cost')" md-numeric>{{
              item.costs.cost | currency(displayCurrency)
            }}</md-table-cell>
            <md-table-cell
              v-if="!hasCreditKind"
              :md-label="L('credit')"
              md-numeric
              >{{
                item.costs.credit | currency(displayCurrency)
              }}</md-table-cell
            >
            <md-table-cell
              v-if="hasCreditKind"
              :md-label="L('discount')"
              md-numeric
              >{{
                item.costs.discount | currency(displayCurrency)
              }}</md-table-cell
            >
            <md-table-cell
              v-if="hasCreditKind"
              :md-label="L('promotion')"
              md-numeric
              >{{
                item.costs.others | currency(displayCurrency)
              }}</md-table-cell
            >
            <md-table-cell
              v-if="hasCreditKind"
              :md-label="L('finalCost')"
              md-numeric
              >{{
                item.costs.finalCost | currency(displayCurrency)
              }}</md-table-cell
            >
          </md-table-row>
        </md-table>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="detailDialog.show = false">{{
          L('close')
        }}</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import api from '@/api'
import {
  objectAdd,
  objectClone,
  convertCosts,
  makeForecastData,
} from '@/lib/utils'
import { getProject, getKindData } from '@/lib/aggutil'
import { getDaysInMonth, getLastDay } from '@/lib/dateutil'
import { getExchangeRate } from '@/lib/exchangeRate'
import ProjectToolbar from './ProjectToolbar'
import MonthlyCost from './Summary.MonthlyCost'
import PromotionCredit from './Summary.PromotionCredit'
import CostShare from './Summary.CostShare'
import DailyCost from './Summary.DailyCost'

export default {
  components: {
    ProjectToolbar,
    MonthlyCost,
    PromotionCredit,
    CostShare,
    DailyCost,
  },

  data() {
    return {
      summaryData: null,
      promotionCreditData: [],
      accountProject: {
        all: false,
        list: [],
      },
      detailDialog: {
        show: false,
        title: '',
        fields: [],
        data: [],
      },
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      curAccount: (state) => state.curAccount,
      curMonth: (state) => state.curMonth,
      preMonth: (state) => state.preMonth,
      curProject: (state) => state.curProject,
      exchangeRateList: (state) => state.exchangeRateList,
      creditFilter: (state) => state.creditFilter,
      displayCurrency: (state) => state.displayCurrency,
    }),

    hasProject() {
      return this.$config.feature.project
    },

    hasCreditKind() {
      return this.$config.feature.creditKind
    },

    projectId() {
      return this.curProject.id
    },

    thisInvoiceMonth() {
      return this.curMonth.replace('-', '')
    },

    lastInvoiceMonth() {
      return this.preMonth.replace('-', '')
    },

    thisMonth() {
      return this.curMonth
    },

    lastMonth() {
      return this.preMonth
    },

    // component data

    thisMonthCostContent() {
      return this.makeMonthlyCostContent(this.thisInvoiceMonth)
    },

    lastMonthCostContent() {
      return this.makeMonthlyCostContent(this.lastInvoiceMonth)
    },

    costByCountryContent() {
      return this.makeCostShareContent('cost_by_country', 'country_name')
    },

    costByRegionContent() {
      return this.makeCostShareContent('cost_by_region', 'region_name')
    },

    costByProjectContent() {
      return this.getKindData('monthly_cost')
        .filter(
          (d) =>
            d.project_id !== '__total' &&
            d.data.some((item) => item.invoice_month === this.thisInvoiceMonth)
        )
        .map((elem) => ({
          name:
            elem.project_id === '__account'
              ? `(${this.L('account')})`
              : elem.project_name,
          cost: elem.data
            .filter((d) => d.invoice_month === this.thisInvoiceMonth)
            .reduce((sum, d) => sum + this.convertCosts(d.costs).finalCost, 0),
        }))
    },

    costByServiceContent() {
      return this.makeCostShareContent('cost_by_service', 'service_name')
    },

    dailyCostContent() {
      const data = this.getProjectData('daily_cost', this.projectId)
        .map((d) => ({
          month: `${d.invoice_month.slice(0, 4)}-${d.invoice_month.slice(
            4,
            6
          )}`,
          date: d.date,
          cost: this.convertCosts(d.costs).finalCost,
        }))
        .sort((a, b) => a.date.localeCompare(b.date))

      const filtered = data.filter((d) => d.month === d.date.slice(0, 7))

      ;[this.thisMonth, this.lastMonth].forEach((month) => {
        const extraCost = data
          .filter((d) => d.month === month && !d.date.startsWith(month))
          .reduce((c, v) => c + v.cost, 0)

        const firstDateData = filtered.find((d) => d.date === `${month}-01`)
        if (firstDateData) {
          firstDateData.cost += extraCost
        } else {
          filtered.push({ month, date: `${month}-01`, cost: extraCost })
        }
      })

      const thisMonthDays = getDaysInMonth(this.thisMonth)
      const lastMonthDays = getDaysInMonth(this.lastMonth)
      const { dataPresentDays, forecasts } = makeForecastData(
        filtered,
        this.thisMonth
      )

      const content = [
        [
          'Date',
          this.thisMonth,
          this.lastMonth,
          ...(forecasts.length > 0
            ? [`${this.thisMonth} (${this.L('forecast')})`]
            : []),
        ],
      ]

      for (
        let i = 1, end = Math.max(thisMonthDays, lastMonthDays);
        i <= end;
        i += 1
      ) {
        const day = String(i).padStart(2, '0')
        const thisVal = filtered.find(
          (c) => c.date === `${this.thisMonth}-${day}`
        )
        const lastVal = filtered.find(
          (c) => c.date === `${this.lastMonth}-${day}`
        )
        const forecastVal = forecasts.find(
          (c) => c.date === `${this.thisMonth}-${day}`
        )
        const thisCost = thisVal ? thisVal.cost : 0
        const lastCost = lastVal ? lastVal.cost : 0
        const forecastCost = forecastVal ? forecastVal.cost : null

        content.push([
          day,
          i <= dataPresentDays ? thisCost : null,
          i <= lastMonthDays ? lastCost : null,
          ...(forecasts.length > 0 ? [forecastCost] : []),
        ])
      }
      return content
    },

    dailyStackedCostContent() {
      const content = objectClone(this.dailyCostContent)

      for (let i = 2; i < content.length; i += 1) {
        if (content[i][1] !== null) {
          content[i][1] += content[i - 1][1]
        }
        if (content[i][2] !== null) {
          content[i][2] += content[i - 1][2]
        }
        if (content[i].length === 4 && content[i][3] !== null) {
          if (content[i - 1][3] !== null) {
            content[i][3] += content[i - 1][3]
          } else {
            content[i][3] += content[i - 1][1]
          }
        }
      }

      return content
    },

    costShareClass() {
      let count = 1
      count += this.$config.feature.costByCountry ? 1 : 0
      count += this.$config.feature.costByRegion ? 1 : 0
      count +=
        this.$config.feature.project && this.projectId === '__total' ? 1 : 0

      const size = Math.floor(100 / count)

      return [
        'md-layout-item',
        `md-xlarge-size-${size}`,
        `md-large-size-${size}`,
        `md-medium-size-${size}`,
        'md-small-size-100',
        'md-xsmall-size-100',
      ]
    },

    preMonthLastDay() {
      return getLastDay(this.preMonth)
    },
  },

  watch: {
    curAccount() {
      this.load()
    },
    curMonth() {
      this.load()
    },
  },

  methods: {
    getExchangeRate(currency, context) {
      const er = this.exchangeRateList.find(
        (e) => e.month === context.month && e.code === currency
      )
      return er ? er.send_rate : { finalCost: 0 }
    },

    convertCosts(costs, thisMonth) {
      const month = thisMonth || this.curMonth
      return convertCosts(
        costs,
        this.displayCurrency,
        this.getExchangeRate.bind(this),
        { month },
        this.creditFilter
      )
    },

    getKindData(kind) {
      return getKindData(this.summaryData, kind)
    },

    getProjectData(kind, projectId) {
      if (projectId) {
        return getKindData(this.summaryData, kind, projectId)
      }
      return []
    },

    makeMonthlyCostContent(invoiceMonth) {
      let finalCost = 0
      const month = `${invoiceMonth.slice(0, 4)}-${invoiceMonth.slice(4, 6)}`

      const monthData = this.getProjectData(
        'monthly_cost',
        this.projectId
      ).find((d) => d.invoice_month === invoiceMonth)
      if (monthData) {
        ;({ finalCost } = this.convertCosts(monthData.costs, month))
      }

      return {
        month,
        cost: finalCost,
        fromDate: `${month}-01`,
        toDate: moment
          .min(moment(invoiceMonth, 'YYYYMM').endOf('months'), moment())
          .format('YYYY-MM-DD'),
      }
    },

    makeCostShareContent(kind, nameProp) {
      return this.getProjectData(kind, this.projectId).map((elem) => ({
        name: elem[nameProp],
        cost: this.convertCosts(elem.costs).finalCost,
      }))
    },

    async load() {
      if (!this.curAccount.id) return

      const months = [this.curMonth, this.preMonth]
      await getExchangeRate(months)

      this.summaryData = await api.aggregate.summary(
        this.curAccount.id,
        this.curMonth
      )
      if (this.summaryData.length === 0) {
        this.summaryData = await api.aggregate.summary(
          this.curAccount.id,
          this.preMonth
        )
        this.summaryData = this.summaryData.filter((data) =>
          ['daily_cost', 'monthly_cost'].includes(data.kind)
        )
      }
      const promotionCredits = await api.promotionCredit.list(
        this.curAccount.id
      )
      if (this.$config.feature.accountBalance) {
        const types = this.$config.accountBalanceTypes

        const promotionCreditHistories =
          await api.promotionCredit.latestHistory(
            this.curAccount.id,
            this.preMonthLastDay,
            {
              timezone: this.$config.timezone,
            }
          )

        const promotionCreditFiltered = promotionCredits.filter((credit) =>
          types.includes(credit.id)
        )
        const promotionCreditHistoriesFiltered = promotionCreditHistories
          .filter((credit) => types.includes(credit.id))
          .map((credit) => ({
            ...credit,
            name: `(${this.preMonthLastDay}) ${credit.name}`,
            id: `(${this.preMonthLastDay}) ${credit.id}`,
          }))

        this.promotionCreditData = [
          ...promotionCreditFiltered,
          ...promotionCreditHistoriesFiltered,
        ]
      } else {
        this.promotionCreditData = promotionCredits
      }

      this.accountProject = getProject(
        this.summaryData,
        this.userInfo,
        this.curAccount
      )
      if (!this.curProject.id) {
        const curProject = { id: null, name: '' }
        if (!this.accountProject.all && this.accountProject.list.length > 0) {
          curProject.id = this.accountProject.list[0].id
          curProject.name = this.accountProject.list[0].name
        } else if (this.accountProject.all) {
          curProject.id = '__total'
        }
        this.$store.commit('curProject', curProject)
      }
    },

    makeServiceDetail(name) {
      const list = this.getKindData('cost_by_service')
        .filter((p) => p.project_id !== '__total')
        .map((p) => ({
          project:
            p.project_id === '__account'
              ? `(${this.L('account')})`
              : p.project_name,
          data: p.data.find((s) => s.service_name === name),
        }))
        .filter((p) => p.data)
        .map((p) => ({
          project: p.project,
          costs: this.convertCosts(p.data.costs),
        }))
        .sort((a, b) => b.costs.finalCost - a.costs.finalCost)

      return {
        title: `${this.L('service')}: ${name}`,
        fields: this.hasProject ? ['project'] : [],
        list,
      }
    },

    makeProjectDetail(name) {
      const projectData = this.getKindData('cost_by_service').find(
        (p) =>
          p.project_name === name ||
          (name === `(${this.L('account')})` && p.project_id === '__account')
      )
      if (!projectData) {
        return null
      }

      const list = projectData.data
        .map((s) => ({
          service: s.service_name,
          costs: this.convertCosts(s.costs),
        }))
        .sort((a, b) => b.costs.finalCost - a.costs.finalCost)

      return {
        title: `${this.L('project')}: ${name}`,
        fields: ['service'],
        list,
      }
    },

    makeRegionDetail(name) {
      const listOfList = this.getKindData('usage_detail')
        .filter((p) => p.project_id !== '__total')
        .map((p) => ({
          project:
            p.project_id === '__account'
              ? `(${this.L('account')})`
              : p.project_name,
          data: p.data.filter((v) => v.region_id === name.replace('*', '')),
        }))
        .map((p) =>
          [...new Set(p.data.map((v) => v.service_name))].map((service) => ({
            project: p.project,
            service,
            costs: p.data
              .filter((v) => v.service_name === service)
              .reduce((c, v) => objectAdd(c, this.convertCosts(v.costs)), {}),
          }))
        )

      const list = []
        .concat(...listOfList)
        .sort((a, b) => b.costs.finalCost - a.costs.finalCost)

      return {
        title: `${this.L('region')}: ${name}`,
        fields: this.hasProject ? ['project', 'service'] : ['service'],
        list,
      }
    },

    makeCountryDetail(name) {
      const listOfList = this.getKindData('usage_detail')
        .filter((p) => p.project_id !== '__total')
        .map((p) => ({
          project:
            p.project_id === '__account'
              ? `(${this.L('account')})`
              : p.project_name,
          data: p.data.filter((v) => v.country_name === name),
        }))
        .map((p) =>
          [...new Set(p.data.map((v) => v.service_name))].map((service) => ({
            project: p.project,
            service,
            costs: p.data
              .filter((v) => v.service_name === service)
              .reduce((c, v) => objectAdd(c, this.convertCosts(v.costs)), {}),
          }))
        )

      const list = []
        .concat(...listOfList)
        .sort((a, b) => b.costs.finalCost - a.costs.finalCost)

      return {
        title: `${this.L('country')}: ${name}`,
        fields: this.hasProject ? ['project', 'service'] : ['service'],
        list,
      }
    },

    openDetailPopup(type, name) {
      let detail

      switch (type) {
        case 'costByService':
          detail = this.makeServiceDetail(name)
          break
        case 'costByProject':
          detail = this.makeProjectDetail(name)
          break
        case 'costByRegion':
          detail = this.makeRegionDetail(name)
          break
        case 'costByCountry':
          detail = this.makeCountryDetail(name)
          break
        default:
          break
      }

      if (detail) {
        this.detailDialog = Object.assign(detail, { show: true })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.md-content {
  margin: 10px 8px 8px 8px;
}

.first-line ::v-deep .md-card {
  height: 200px;
}

::v-deep {
  .md-card {
    margin: 8px;
  }

  .md-card-header {
    padding: 8px 16px;

    .md-title {
      font-size: 20px;
    }
  }

  .md-card-content {
    font-size: 25px;

    &:last-of-type {
      padding-bottom: 16px;
    }
  }

  .md-card-actions {
    font-size: 15px;
  }
}

.md-toolbar ::v-deep .md-toolbar-section-end {
  flex: 4;
}

.md-dialog-big ::v-deep .md-dialog-container {
  min-width: 1200px;
}
</style>
